// extracted by mini-css-extract-plugin
module.exports = {"list":"categories-list_list__wkaMj","columnSpan":"categories-list_columnSpan__FAi5j","splitInColumns":"categories-list_splitInColumns__x9Vui"};